import arrayCheck from "Helpers/arrayCheck";
import he from "he";
import { checkImageViews, imageDynamic, imageDynamic2 } from "../../../helpers/utils";
/**
 * Predefine user_reviews
 * @param {*} reviews
 */

const predefinedPhotos = (photos = []) => photos.map((photo) => (
	{
		...photo,
		img_url: checkImageViews(photo.img_url).match(
			/image.femaledaily.com/,
		)
			? imageDynamic2(photo.img_url, 600)
			: imageDynamic(photo.img_url, 600),
	}
));

const decodeText = (text) => {

	try {
		const decodedText = he.decode(text);
		return decodedText;
	} catch (err) {
		return "";
	}

};

const predefinedReview = (params = {}) => {

	if (params?.id) {

		const result = {
			id: params?.id,
			reviewer_id: params?.id,
			date: params?.created_at,
			user_id: params?.user.id,
			text: decodeText(params?.review),
			is_recommended: params?.is_recommended,
			is_like: params?.is_like,
			is_firsttime_use: params?.is_firsttime_use,
			place_to_get: params?.place_to_get,
			duration_of_use: params?.duration_of_use,
			total_likes: params?.total_likes ?? 0,
			total_comments: params?.total_comments ?? 0,
			is_expand: false,
			comment: "",
			comments: {
				data: [],
				pagination: {},
			},
			// user
			user: {
				id: params?.user.id,
				username: params?.user.username,
				picture: params?.user.picture.large,
				age_range: params?.user.age_range,
				beauty_level: params?.user.level,
				skin: {
					type: params?.user?.beauty_profile?.skin_type_name,
					tone: params?.user?.beauty_profile?.skin_tone_name,
					undertone: params?.user?.beauty_profile?.skin_undertone_name,
				},
			},
			rating: {
				user: params?.rating_user,
				average: params?.product_variant?.rating?.rating_overall ?? 0,
				total: params?.total_review ?? 0,
			},
			product: {
				id: params?.product_variant?.id,
				image: Array.isArray(params?.product_variant?.assets) ? params?.product_variant?.assets?.[0].url ?? "" : "",
				name: params?.product_variant?.product?.name,
				slug: params?.product_variant?.slug,
				shade: params?.product_variant?.name,
				brand: {
					name: params?.product_variant.brand.name,
					slug: params?.product_variant.brand.slug,
				},
				category: {
					name: arrayCheck(params?.product_variant?.categories)
						? params?.product_variant?.categories?.[0]?.name ?? ""
						: "",
					slug: arrayCheck(params?.product_variant?.categories)
						? params?.product_variant?.categories?.[0]?.slug ?? ""
						: "",
					parent: {
						name: arrayCheck(params?.product_variant?.categories)
							? params?.product_variant?.categories?.[0]?.parent?.name || ""
							: "",
						slug: arrayCheck(params?.product_variant?.categories)
							? params?.product_variant?.categories?.[0]?.parent?.slug || ""
							: "",
					},
				},
				rating: {
					user: params?.rating_user,
					average: params?.product_variant?.rating?.rating_overall,
					total: params?.product_variant?.total_review,
				},
			},
			photos: params?.images?.length > 0 ? predefinedPhotos(params.images) : [],

		};

		return result;

	}

	return null;

};

const predefinedReviews = (params = []) => {

	if (params.length > 0) {

		return params.map((item) => predefinedReview(item));

	}

	return [];

};

export default predefinedReviews;
